<template>
  <div>
    <el-submenu v-if="children&&children.length>0" :index="url">
      <template slot="title">
        <i :class="icon"></i>
        <span>{{name}}</span>
      </template>
      <menu-item v-for="(menu,key) in children" :key="key" :url="menu.url" :icon="menu.icon" :name="menu.name"
        :children="menu.children">
      </menu-item>
    </el-submenu>
    <el-menu-item v-else :index="url">
      <i :class="icon"></i>
      <span slot="title">{{name}}</span>
    </el-menu-item>
  </div>
</template>
<script>
  export default {
    name: "MenuItem",
    data() {
      return {};
    },
    props: ["url", "icon", "name", "children"]
  };

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Menu/MenuItem.vue